import { render, staticRenderFns } from "./MyPurchaseDetail.vue?vue&type=template&id=1de11a30&"
import script from "./MyPurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./MyPurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyPurchaseDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports